<template>
  <div class="product-card-skeleton">
    <!-- Блок изображения -->
    <div class="product-card-skeleton__media skeleton-shimmer" />

    <div class="product-card-skeleton__body">
      <!-- Название (2 линии) -->
      <div class="product-card-skeleton__name">
        <div class="skeleton-line skeleton-shimmer" style="width: 100%;" />
        <div class="skeleton-line skeleton-shimmer" style="width: 70%;" />
      </div>

      <!-- Теги и цена -->
      <div class="product-card-skeleton__row">
        <div class="product-card-skeleton__tags">
          <div class="skeleton-tag skeleton-shimmer" />
          <div class="skeleton-tag skeleton-shimmer" />
        </div>
        <div class="product-card-skeleton__price">
          <div class="skeleton-line skeleton-shimmer" style="width: 80px; height: 24px;" />
        </div>
      </div>

      <!-- Характеристики -->
      <div class="product-card-skeleton__chars">
        <div class="skeleton-char skeleton-shimmer" />
        <div class="skeleton-char skeleton-shimmer" />
      </div>

      <!-- Кнопка -->
      <div class="product-card-skeleton__button skeleton-shimmer" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.product-card-skeleton {
  display: flex;
  flex-direction: column;
  background: white;
  border-radius: 20px;
  border: 1px solid #EBEBEB;
  overflow: hidden;
  height: 100%;
}

.product-card-skeleton__media {
  width: 100%;
  position: relative;
  border-radius: 20px 20px 5px 5px;
  background: #F4F3F1;

  &:after {
    content: "";
    float: left;
    padding: 38.53%;
  }
}

.product-card-skeleton__body {
  padding: 0 12px;
  display: flex;
  height: 297px;
  flex-direction: column;
}

.product-card-skeleton__name {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.skeleton-line {
  height: 16px;
  border-radius: 4px;
}

.product-card-skeleton__row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 4px;
}

.product-card-skeleton__tags {
  display: flex;
  gap: 6px;
}

.skeleton-tag {
  width: 50px;
  height: 24px;
  border-radius: 6px;
}

.product-card-skeleton__chars {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 8px;
}

.skeleton-char {
  height: 32px;
  border-radius: 6px;
}

.product-card-skeleton__button {
  height: 48px;
  border-radius: 12px;
  margin-top: auto;
}

@media (max-width: 1023px) {
  .product-card-skeleton__body {
    padding: 16px;
  }

  .product-card-skeleton__button {
    margin-top: 24px;
  }
}

.skeleton-shimmer {
  background: linear-gradient(
    90deg,
    #f0f0f0 0%,
    #e0e0e0 20%,
    #f0f0f0 40%,
    #f0f0f0 100%
  );
  background-size: 200% 100%;
  animation: skeleton-loading 1.5s ease-in-out infinite;
}

@keyframes skeleton-loading {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
</style>

